import axios from 'axios';

class AuthenticationService {
  constructor() {
    this.isAuthenticated = false;
    this.user = null;
  }

  /**
   * Initializes the authentication state by calling the server’s `decryptToken` endpoint.
   * If successful, sets `this.user` and `this.isAuthenticated`, and also stores some data
   * in `sessionStorage` for downstream use.
   */
  async initialize() {
    try {
      this.rockId = this.getCookieByKey(process.env.NEXT_PUBLIC_AUTH_COOKIE);
      if (this.rockId) {
        const {
          data: { data: userData }
        } = await axios.get(`${process.env.NEXT_PUBLIC_CRDS_SITE_DOMAIN}api/getCurrentPerson`, {
          params: { accessToken: this.rockId, project: 'UC' },
          headers: { 'Content-Type': 'application/json' }
        });
        console.log(userData);
        this.user = userData;
        this.isAuthenticated = true;
        // Store user data in sessionStorage so other parts of the app can access it if needed
        if (this.user) {
          sessionStorage.setItem('RockUserID', this.user.Id || '');
          sessionStorage.setItem('RockUserEmail', this.user.Email || '');
          sessionStorage.setItem('RockUserLocation', this.user.PrimaryCampusName || '');
        }
      }
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      this.isAuthenticated = false;
      this.user = null;
    }
  }

  getCookieByKey = (key) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${key}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  /**
   * Initiates the login process by redirecting to the Auth0 login endpoint.
   * The server-side (at `NETLIFY_API_DOMAIN`login) should handle the Auth0 flow
   * and set the appropriate cookies or tokens.
   */
  async login() {
    window.location.replace(`${process.env.NEXT_PUBLIC_CRDS_ROCK_DOMAIN}login`);
  }

  /**
   * Initiates the logout process by redirecting to the Auth0 logout endpoint.
   * Also clears sessionStorage of user data.
   */
  async logout() {
    sessionStorage.removeItem('RockUserID');
    sessionStorage.removeItem('RockUserEmail');
    sessionStorage.removeItem('RockUserLocation');
    window.location.replace(`${process.env.NEXT_PUBLIC_CRDS_ROCK_DOMAIN}Auth/Logout`);
  }

  /**
   * Returns the current user object if authenticated, otherwise `null`.
   */
  getUser() {
    return this.user;
  }

  /**
   * Returns a boolean indicating if the user is currently authenticated.
   */
  getIsAuthenticated() {
    return this.isAuthenticated;
  }
}

// Create a singleton instance of AuthenticationService
const AuthProvider = new AuthenticationService();

export default AuthProvider;
export { AuthenticationService, AuthProvider };
